module.exports = __webpack_public_path__ + "img/XCP.0f724f52.svg";